<template>
    <div class='full-width'>
        <div class='row no-wrap items-center'>
            <div class="col-1 text-center"><q-btn flat dense icon='list' color='primary' @click='showDetails = !showDetails' class='q-mr-md'/>{{order.id}}</div>
            <div class="col-2 text-center">{{getContragent(order.contragent)}}</div>
            <div class="col-2 text-center">{{getExecutor(order.executor)}}</div>
            <div class="col-2 text-center">{{getManager(order.manager)}}</div>
            <div class="col-1 text-center">{{order.orderCost}}</div>
            <div class="col-1 text-center">
                <div v-if='order.pay_summ > 0'>
                    {{order.pay_summ}}
                    <q-tooltip  :delay='1000'>
                        <div v-for="(p, k) in order.pay_info" :key='k'> 
                            {{k}} {{p}}
                        </div>
                    </q-tooltip>
                </div>
                <div v-if='order.pay_summ == 0'>
                    -
                </div>
            </div>
            <div class='col-1 text-center'>
                {{order.debit}}
            </div>
            <div class='col-2 text-center'>
                {{getDebitBill(order.bill_out).number}}<br>
                {{getDebitBill(order.bill_out).org}}
            </div>
        </div>
        <detailsLine
            :orderId = order.id
            :key = order.id
            v-bind:isVisible = 'showDetails'
            class='shadow-1 q-mt-md'
        />
    </div>
</template>

<script>
export default {
    name : 'billDebitLine',
    
    data() {
        return {
            showDetails : false,
        }
    },

    props : {
        order : Object,
    },

    components : {
        detailsLine : ()=>import('./../orderlist/orderLineDetails.vue')
    },

    methods : {
        getContragent(id) {
            let q = this.$store.getters.getContragentById(id);
            return q != null ? q.name : "-";
        },
        
        getExecutor(id) {
            let q = this.$store.getters.getExecuterById(id);
            return q != null ? q.name : '-';
        },

        getManager(id) {
            let q = this.$store.getters.getUserById(id);
            return q != null ? q.name+' ' + q.surname : '-';
        },
        
        getDebitBill(bill_out) {
            let result = {};
            let b = this.$store.getters.getDebitBillById(bill_out);
            if (b.number == null) {
                result.number = '-';
                result.org = '';
            } else 
            {
                let org = this.$store.getters.getOrganizationById(b.org);
                result.number = 'счет № '+b.number;
                result.org = org != null ? org.name : '';
            }
            return (result);
        },


    }

}
</script>

<style>

</style>
